import './_terms.scss';

const CreatorTerms = () => {

  return (
    <>
    <div className="pf-content pf-content--not-home">
        <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">
             Creator Terms
            </h2>
            <div className="pf-page__descr">
            <p>
              This creator supplement supplements AllFans’s <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, 
              between AllFans and Creator. This supplement sets out the terms by which 
              Creator may offer Content for sale and interact with Fans using the Website. 
              Capitalized terms not defined in this supplement are defined in the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>.
            </p>
            </div>
          <ol className="pf-main-list">
            <li>
              <h5>Terms-of-Service Agreement</h5>
              <p>
                The terms of the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a> remain in full effect, except 
                that if any inconsistency exists between this supplement and the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, this supplement will prevail.
              </p>
            </li>
            <li>
              <h5>Eligibility</h5>
              <p>
                Creator must be an individual who (1) is at least 18 years old (19 in Canada) 
                and the age of majority in the jurisdiction in which Creator is located and (2) 
                has the legal capacity to enter into legally binding contracts.
              </p>
            </li>
            <li>
              <h5>Registration</h5>
              <p>
                To register, Creator must complete the “Creator” registration form and submit 
                a copy of Creator’s valid government-issued picture identification card (in color) 
                that contains Creator’s legal name, date of birth, expiration date, and any other 
                information required by section 4 for identity and age verification purposes. If 
                Creator lives in the US, Creator must also submit a completed W-9 Form. If Creator 
                lives outside the US, Creator must submit a completed W-8BEN Form. By registering, 
                Creator states that the following facts are accurate: (1) all account registration 
                information is accurate; (2) if Creator previously had an account, Creator’s old 
                account was not terminated or suspended by AllFans for violation of this 
                supplement, the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, or the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>; (3) 
                Creator’s registration is for Creator’s own use, and Creator must not otherwise 
                sell, rent, or transfer Creator’s account to another person; and (4) Creator must 
                not use any third-party payment provider to accept payments for any Content.
              </p>
            </li>
            <li>
              <h5>Age Verification</h5>
              <p>
                AllFans has a robust process for verifying the identity and age of every 
                Creator. This process includes the review and validation of Creator’s 
                government-issued picture identification card and steps to ensure that Creator’s 
                government-issued picture identification card is in the possession of, and belongs 
                to, Creator. This process requires that Creator provide AllFans a live 
                capture of: (1) Creator’s face; (2) Creator’s valid and accurate government-issued 
                picture identification card (front and back, where applicable); and (3) Creator 
                holding Creator’s government-issued picture identification card. This process is 
                to ensure that individuals are present, are live, and consent to the application 
                process. AllFans uses a number of tools to validate government-issued 
                picture identification cards, including third-party vendors that specialize in 
                the validation of government identifications. <strong>Creator hereby authorizes 
                AllFans to verify the validity of Creator’s government-issued picture 
                identification card with a nonparty verification service.</strong>
              </p>
            </li>
            <li>
              <h5>Platform Fee</h5>
              <p>
                AllFans will deduct 20% of all Fan Payments made to Creator (exclusive of 
                any Tax element of the Fan Payment) (“Platform Fee”). AllFans will pay the 
                remaining 80% of the Fan Payment (exclusive of any Tax element of the Fan Payment) 
                to Creator (“Creator Earnings”). Occasionally, AllFans may pay eligible 
                Creators a higher revenue share during special promotions (thus temporarily reducing 
                the Platform Fee). Any higher revenue shares will be subject to the terms set out 
                in the promotion. The Platform Fee includes AllFans’s cost of providing the 
                services (including hosting and storing the Content) and maintaining and operating 
                the Website. AllFans will deduct the Platform Fee from the Fan Payment, 
                and AllFans will pay the Creator Earnings to Creator as set out in section 10.
              </p>
            </li>
            <li>
              <h5>Fan/Creator Transactions</h5>
              <ol>
                <li>
                  <p>
                    All Fan/Creator Transactions are contracts between Fans and Creators on the 
                    terms of the <a href='/fancreatorcontract' className='terms-link'>Standard Agreement between Fan and Creator</a>. Although AllFans 
                    facilitates Fan/Creator Transactions by providing the Website, storing Content, 
                    and acting as a payment intermediary, AllFans is not a party to the 
                    <a href='/fancreatorcontract' className='terms-link'>Standard Agreement between Fan and Creator</a> or any other contract that might exist 
                    between a Fan and Creator, and AllFans is not responsible for any Fan/Creator 
                    Transaction.
                  </p>
                </li>
                <li>
                  <p>
                    Creator is solely responsible for setting prices for Content. Fan Payments 
                    are exclusive of Taxes, which will be added at the current rate applicable to Fan 
                    Payments. Fans must submit payment using an approved payment method through the 
                    Website’s billing interface. Creator must not use any nonparty payment provider 
                    (including Paxum, PayPal, Venmo, Zelle, etc.) to accept payments for any Content.
                  </p>
                </li>
                <li>
                  <p>
                    When Creator receives confirmation from AllFans, either on Creator’s 
                    User account or by email or both, that the Fan/Creator Transaction has been 
                    confirmed, Creator must perform Creator’s part of that Fan/Creator Transaction 
                    (for example, by allowing the Fan to view the Content on Creator’s account, 
                    providing the customized Content paid for by the Fan, or allowing the Fan to use 
                    the fan interaction function paid for (as applicable)). Creator shall indemnify 
                    AllFans against any breach by Creator of these obligations, including any 
                    loss or damage (including loss of profits) that AllFans suffers because of 
                    Creator’s failure to comply with these obligations.
                  </p>
                </li>
              </ol>
            </li>  
            <li>
              <h5>Content</h5>
              <ol>
                <li>
                  <p>
                    Creator may create, upload, send, display, or livestream various Content to 
                    Creator’s account. Creator acknowledges that AllFans merely provides Creator 
                    the means to distribute Content through AllFans’s computer systems. Content 
                    must not include nonparty intellectual property (including copyrighted material) 
                    unless Creator has a written license or consent from that person or is otherwise 
                    legally entitled to do so. Creator hereby (1) consents to be depicted in the Content; 
                    (2) consents to allow for the public distribution of the Content and to upload the 
                    Content to the Website; and (3) if the Content will be made available for downloading 
                    by Users, consents to have the Content downloaded.
                  </p>
                </li>
                <li>
                  <p>
                    Creator shall act as the custodian of records for the Content that Creator’s uploads to the Website.
                  </p>
                </li>
                <li>
                  <p>
                    AllFans does not claim any ownership interest in the Content. Creator continues 
                    to retain any ownership interest that Creator might have in the Content subject to the 
                    licenses granted in section 7(d).
                  </p>
                </li>
                <li>
                  <p>By making Content available on the Website or otherwise posting on the Website, 
                    Creator hereby grants AllFans a perpetual, irrevocable, nonexclusive, sublicensable, 
                    worldwide license covering Creator’s Content or what Creator’s posts in all formats and 
                    channels know known or later developed anywhere in the world to use, copy, reproduce, store, 
                    translate, transmit, distribute, perform, prepare derivative works, publicly display, and 
                    display in connection with any name, username, voice, or likeness provided in connection 
                    with it.
                  </p>
                </li>
                <li>
                  <p>
                    The licenses granted in section 7(d) will continue as long as Creator offers the 
                    Content for sale. If Creator removes Content, AllFans may continue to make the 
                    Content available to those Fans who previously purchased the Content or provide full or 
                    partial refunds to those persons. In addition, AllFans may retain archival copies: 
                    (1) for a limited period in case Creator wishes to restore it; (2) when the Content is the 
                    subject of a takedown notice or other legal claim; or (3) when AllFans in good 
                    faith believes that it is legally obligated to do so.
                  </p>
                </li>
                <li>
                  <p>
                    Creator hereby waives all claims Creator might now or later have in any jurisdiction 
                    to so-called “moral rights” or rights of droit moral in Content.
                  </p>
                </li>  
                <li>
                  <p>
                    AllFans is not responsible for and does not endorse any aspect of any 
                    Content posted by Creator or any other User on the Website.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>Creator Advertising</h5>
              <ol>
                <li>
                  <p>
                    If Creator posts or uploads video Content to Creator’s account that is 
                    designed to promote, directly or indirectly, nonparty goods or services in 
                    exchange for payment, other valuable consideration, or self-promotional purposes 
                    (including advertising, sponsorship, and product placement) (collectively, 
                    “Advertising Content”), Creator must comply with sections 8(b) and 8(c).
                  </p>
                </li>
                <li>
                  <p>
                    Creator must ensure that any Advertising Content that Creator posts to Creator’s account:
                  </p>
                  <ol>
                    <li>
                      <p>does not:</p>
                      <ol className="alpha-list">
                        <li>
                          <p>
                            prejudice respect for human dignity;
                          </p>
                        </li>
                        <li>
                          <p>
                            include or promote bigotry, racism, or discrimination based on race, ethnicity, 
                            gender, religion or belief, nationality, disability, sexual orientation, or age;
                          </p>
                        </li>
                        <li>
                          <p>
                            encourage behavior prejudicial to health or safety;
                          </p>
                        </li>
                        <li>
                          <p>
                            encourage behavior grossly prejudicial to the protection of the environment;
                          </p>
                        </li>
                        <li>
                          <p>
                            cause physical, mental, or moral distress to any person;
                          </p>
                        </li>
                        <li>
                          <p>
                            directly urge persons to purchase or rent goods or 
                            services in a way that exploits their inexperience or credulity;
                          </p>
                        </li>
                        <li>
                          <p>
                            directly encourages persons to persuade others to purchase or rent goods or services;
                          </p>
                        </li>
                        <li>
                          <p>
                            exploit the trust of persons in others; or
                          </p>
                        </li>
                        <li>
                          <p>
                            unreasonably shows persons in dangerous situations;
                          </p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>does not advertise cigarettes and other tobacco products, electronic cigarettes and 
                        electronic cigarette refill containers, illegal drugs, or any prescription-only medicine;</p>
                    </li>
                    <li>
                      <p>does not advertise, promote, or facilitate illegal gambling; and</p>
                    </li>
                    <li>
                      <p>regarding any Advertising Content for alcoholic drinks, is 
                        not aimed at minors and does not encourage excessive consumption of alcohol.</p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    Creator must declare that any Advertising Content that Creator posts or uploads to 
                    the Website contains advertising by including the signifier #ad or # sponsored in the 
                    caption to the Advertising Content before posting or uploading.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>Co-Authored Content</h5>
              <ol>
                <li>
                  <p>
                    If Creator uploads Content to Creator’s account that depicts anyone 
                    other than or besides Creator (even if that person cannot be identified from the Content) 
                    (“Co-Authored Content”), Creator states that each individual shown in any Co-Authored Content 
                    uploaded to Creator’s account is (1) a Creator on the Website; or (2) a consenting adult, and 
                    that Creator has verified the identity and age of each such individual and will provide 
                    supporting documents on AllFans’s request.
                  </p>
                </li>
                <li>
                  <p>
                    Creator further states that Creator has obtained and keeps on record written consent 
                    from each individual shown in Creator’s Co-Authored Content that the individual (1) has given 
                    their express, prior, and informed consent to their appearance in the Co-Authored Content; and 
                    (2) has consented to allow for the public distribution of the Co-Authored Content in which they 
                    appear and to upload the Co-Authored Content to the Website.
                  </p>
                </li>
                <li>
                  <p>
                    Besides the confirmations in sections 9(a) and 9(b), if Creator uploads Co-Authored 
                    Content where the other person or people appearing in the Co-Authored Content have a Creator 
                    account on the Website, Creator must tag the account(s) of any person or people appearing 
                    in the Co-Authored Content who can be identified from it.
                  </p>
                </li>
                <li>
                  <p>
                    If any Co-Authored Content is a work of joint authorship, Creator is solely responsible 
                    for obtaining any required licenses or consents from any other joint authors of the Co-Authored 
                    Content that are sufficient to allow that Co-Authored Content to be uploaded to and made available 
                    on the Website.
                  </p>
                </li>
                <li>
                  <p>
                    (e)	Creator acknowledges that AllFans will only pay Creator Earnings to the account of the 
                    Creator to which the Co-Authored Content is uploaded. The Creator uploading the Co-Authored Content 
                    is solely responsible for dividing and distributing any revenue generated from the Co-Authored Content 
                    between the individuals depicted in that Co-Authored Content. Any revenue-sharing agreement is an 
                    independent, private agreement between Creator and those individuals, and AllFans is not 
                    responsible for supplying or enforcing any such agreements. Creator acknowledges that Creator will 
                    not receive any Creator Earnings earned on any Co-Authored Content in which Creator appears, but 
                    which is posted on another Creator’s account. If Creator posts Co-Authored Content on Creator’s 
                    account, AllFans may require Creator to provide complete legal information for all individuals 
                    who appear in the Co-Authored Content. If Creator does not provide any information requested by 
                    AllFans on its request, AllFans may do one or more of the following: (1) delete the 
                    Co-Authored Content, (2) restrict Creator’s rights and permissions to post as a Creator, (3) terminate 
                    Creator’s account, or (4) withhold any part of Creator Earnings earned but not yet paid out to Creator.
                  </p>
                </li>
                <li>
                  <p>
                    Creator hereby releases AllFans from and will not make any claims against AllFans 
                    arising from the Co-Authored Content. Creator will make all claims arising from the Co-Authored Content 
                    against the Creator who posted the Co-Authored Content or the individuals who appeared in the Co-Authored 
                    Content (as applicable).
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>Creator Earning Payouts</h5>
              <ol>
                <li>
                  <p>
                    All Fan Payments will be received by a nonparty payment provider approved by AllFans. 
                    AllFans will receive the Fan Payment from the relevant payment provider. AllFans 
                    will deduct the Platform Fee from Fan Payment and then will hold Creator Earnings for Creator in 
                    AllFans’s capacity as Creator’s agent.
                  </p>
                </li>
                <li>
                  <p>
                    Creator’s account will be updated within a reasonable time with Creator’s Creator Earnings. 
                    The Creator Earnings will become available for withdrawal by Creator from Creator’s AllFans 
                    account once those Creator Earnings appear in Creator’s AllFans account.
                  </p>
                </li>
                <li>
                  <p>
                    To make a withdrawal of Creator Earnings from Creator’s AllFans account, Creator must 
                    have at least the minimum payout amount in Creator’s AllFans account for the payout option selected.
                  </p>
                </li>
                <li>
                  <p>
                    The amount listed in Creator’s “current balance” in Creator’s AllFans account is Creator’s 
                    Creator Earnings at the relevant time. All Fan Payments and Creator Earnings are transacted in US dollars. 
                    Creator’s bank may charge Creator currency conversion or transfer fees to receive Creator Earnings. 
                    Additionally, Creator’s e-wallet company may charge Creator a fee for accessing the money. AllFans 
                    does not have control over currency exchange rates or charges imposed by Creator’s bank or e-wallet company, 
                    and AllFans is not responsible for paying any charges imposed by Creator’s bank or e-wallet company.
                  </p>
                </li>
                <li>
                  <p>
                    If a Fan successfully seeks a refund or chargeback from their credit card provider for a Fan Payment 
                    made to Creator, AllFans may investigate and may deduct from Creator’s account an amount equal 
                    to Creator Earnings earned by Creator on the chargeback or refunded amount. Creator hereby authorizes 
                    AllFans to dispute any chargebacks made by Fans, and Creator shall assist AllFans in 
                    that dispute. Successful refunds and chargebacks will reduce Creator Earnings payable to Creator but 
                    will not reduce Platform Fees payable to AllFans.
                  </p>
                </li>
                <li>
                  <p>
                    If AllFans cannot pay out Creator Earnings to Creator after 12 months because of inaccurate 
                    information in Creator’s account and AllFans cannot contact Creator, Creator will automatically 
                    forfeit Creator Earnings, and Creator Earnings will become AllFans’s property, except that 
                    Creator Earnings that are deemed unclaimed property will be turned over to the applicable governmental 
                    body if required by law.
                  </p>
                </li>
                <li>
                  <p>
                    If Creator disputes AllFans’s calculation of Creator Earnings, Creator must notify 
                    AllFans in writing no later than 30 days after that disputed calculation. Failure to notify 
                    AllFans within this period will result in Creator’s waiver of any claims related to that 
                    disputed calculation.
                  </p>
                </li>
              </ol>  
            </li>
            <li>
              <h5>Creator Earnings Withholdings</h5>
              <ol>
                <li>
                  <p>
                    AllFans may withhold Creator Earnings due to Creator but not yet paid out: (1) if 
                    AllFans believes that Creator has or might have materially or repeatedly breached any part 
                    of this supplement, the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>, or any law; (2) if 
                    Creator attempts or threatens to breach any part of this supplement, the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, 
                    or the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a> in a way that AllFans believes could have serious consequences 
                    for it or another User (including actual or possible loss caused to AllFans or another User); 
                    or (3) if AllFans suspects that any part of Creator Earnings results from unlawful or fraudulent 
                    activity, either by Creator or by a Fan who made Fan Payment resulting in Creator Earnings, for as 
                    long as is necessary to investigate the actual, threatened, or suspected breach by Creator or the 
                    suspected fraudulent or unlawful activity. If after its investigation, AllFans concludes that 
                    (1) Creator has materially or repeatedly breached any part of this supplement, the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>, or any law; (2) Creator has attempted or threatened to breach 
                    any part of this supplement, the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, or the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a> in a way 
                    that has or could have serious consequences for AllFans or another User (including actual or 
                    possible loss caused to AllFans or another User); or (3) Creator Earnings results from unlawful 
                    or fraudulent activity, AllFans may notify Creator that Creator has forfeited those Creator 
                    Earnings.
                  </p>
                </li>
                <li>
                  <p>
                    AllFans may also withhold Creator Earnings due to Creator but not yet paid out if 
                    AllFans receives notice that Creator has secured, encumbered, pledged, assigned, or otherwise 
                    allowed a lien to be placed on the Creator Earnings. AllFans is not required to pay Creator 
                    Earnings to nonparty lienholders and may withhold payment of Creator Earnings until the lien has 
                    been removed.
                  </p>
                </li>
                <li>
                  <p>
                    AllFans will not have any responsibility to Creator if it withholds or forfeits Creator 
                    Earnings where AllFans has the right to do so under this supplement.
                  </p>
                </li>
                <li>
                  <p>
                    If AllFans is withholding Creator Earnings due to Creator, and AllFans determines 
                    that part of Creator Earnings withheld is unrelated to Creator’s breach or suspected unlawful or 
                    fraudulent activity, AllFans may arrange for Creator to be paid the part of Creator Earnings 
                    that AllFans determines to be unrelated to Creator’s breach or suspected unlawful or 
                    fraudulent activity. However, Creator acknowledges that if AllFans determines that Creator’s 
                    breaches have or might cause AllFans losses, AllFans may withhold all Creator Earnings 
                    due but not yet paid, and AllFans may set off those amounts against any losses AllFans 
                    suffers.
                  </p>
                </li>
                <li>
                  <p>
                    If after AllFans concludes its investigation, it determines that Creator Earnings are 
                    forfeited, AllFans will (unless prohibited by law) use reasonable efforts to ensure that any 
                    Fan Payments that resulted in forfeited Creator Earnings are returned to the relevant Fans who paid 
                    those Fan Payments.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>Taxes</h5>
                <ol>
                  <li>
                    <p>
                      Taxes are solely Creator’s responsibility. AllFans recommends that Creator seek professional 
                      Tax advice to ensure that Creator is compliant with Creator’s Tax obligations under law based on Creator’s 
                      individual circumstances.
                    </p>
                  </li>
                  <li>
                    <p>
                      AllFans may withhold any amounts due to Creator that AllFans determines in good faith 
                      must be withheld under US Tax law or any other law.
                    </p>
                  </li>
                  <li>
                    <p>
                      AllFans may file reports concerning income with any taxing authority, including the US 
                      Internal Revenue Service.
                    </p>
                  </li>
                  <li>
                    <p>
                      Creator states that Creator has reported and will report in the future the receipt of all payments 
                      made to Creator to the relevant tax authority in Creator’s jurisdiction, as required by law.
                    </p>
                  </li>
                  <li>
                    <p>
                      Creator states that Creator will at all times comply with all laws and regulations relating to 
                      Tax that apply to Creator. If, at any point, while Creator has an account on the Website, any Tax 
                      noncompliance occurs relating to Creator (including Creator’s failure to report Creator Earnings or 
                      the imposition on Creator of any penalty or interest relating to Tax) or if any litigation, inquiry, 
                      or investigation is brought against Creator that is in connection with, or that might lead to, any 
                      occurrence of Tax noncompliance, Creator must: (1) notify AllFans by email to support@allfans.com 
                      in writing within five days of the occurrence of the Tax noncompliance or the filing of the litigation, 
                      inquiry, or investigation; and (2) promptly provide AllFans by email to support@allfans.com with: 
                      (A) details of the steps that Creator is taking to address the Tax noncompliance and to prevent it from 
                      happening again, plus any mitigating factors that Creator considers relevant; and (B) that other 
                      information about the Tax noncompliance as AllFans may reasonably require.
                    </p>
                  </li>
                  <li>
                    <p>
                      Creator is solely responsible for Creator’s own Tax affairs, and AllFans (1) is not 
                      responsible for advising Creator on Creator’s Tax affairs and will not be liable for any general 
                      information provided on the Website or by email regarding Tax, and (2) will not be liable for any 
                      nonpayment of Tax by Creator.
                    </p>
                  </li>
                  <li>
                    <p>
                      AllFans may close Creator’s account if it is notified of or becomes aware of any 
                      Tax noncompliance by Creator.
                    </p>
                  </li>
                </ol>
            </li>
            <li>
              <h5>Relationship of the Parties</h5>
              <ol>
                <li>
                  <p>
                    The parties intend that their relationship will be that of independent contractors and not business 
                    partners. This supplement does not, and the parties do not intend to, create a partnership, joint venture, 
                    agency, franchise, or employment relationship. The parties expressly disclaim the existence of any of these 
                    relationships between them. Neither party is the agent for the other. Neither party has the right to bind 
                    the other on any agreement with another person, except that when AllFans receives Creator Earnings, 
                    it is collecting and holding them for Creator until distribution under section 10.
                  </p>
                </li>
                <li>
                  <p>
                    Creator is not eligible under this supplement to participate in any vacation, group medical or life 
                    insurance, disability, profit sharing or retirement benefits, or any other fringe benefits or benefit plans 
                    offered by AllFans to its employees.
                  </p>
                </li>
                <li>
                  <p>
                    AllFans is not responsible for withholding or paying any income, payroll, Social Security, or 
                    other federal, state, or local taxes; making any insurance contributions, including unemployment or 
                    disability; or obtaining worker’s compensation insurance for Creator. Creator is solely responsible for 
                    all those taxes or contributions, including penalties and interest. Creator is also responsible for 
                    keeping adequate worker’s compensation coverage or insurance for Creator and any employee or other personnel 
                    Creator engages.
                  </p>
                </li>
                <li>
                  <p>
                    Any persons employed or engaged by Creator to create, produce, submit, or livestream Content must be 
                    Creator’s employees or contractors, and Creator will be fully responsible for them and indemnify AllFans 
                    against any claims made by or for any such employee or contractor. Creator must require each such employee and 
                    contractor to sign written agreements securing for AllFans all rights granted to AllFans in 
                    this supplement and the written consents required in this supplement before that employee or contractor provides, 
                    creates, livestreams, or otherwise performs or is depicted in any Content, including Co-Authored Content.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>Statements of Fact</h5>
              <p>Creator states that the following facts are accurate and will continue to be accurate during this supplement:</p>
              <ol>
                <li>
                  <p>
                    Creator is at least 18 years old and has the legal capacity to enter into this supplement.
                  </p>
                </li>
                <li>
                  <p>
                    Creator has the power to enter into this supplement, to grant the rights and licenses granted in it, 
                    and to perform Creator’s obligations in this supplement.
                  </p>
                </li>
                <li>
                  <p>
                    Creator is licensed, authorized, and certified by all governmental and regulatory authorities to perform 
                    Creator’s duties and obligations under this supplement.
                  </p>
                </li>
                <li>
                  <p>
                    Creator is not, nor is Creator acting for any person or entity that is, prohibited from engaging in 
                    transactions with US citizens, nationals, or entities under US law, including regulations issued by the 
                    US Office of Foreign Assets Control (OFAC).
                  </p>
                </li>
                <li>
                  <p>
                    Creator is not, nor is Creator acting for any person or entity that is, a Specially Designated National 
                    (SDN), as OFAC may designate on one or more occasions.
                  </p>
                </li>
                <li>
                  <p>
                    Creator has independently evaluated the desirability of using the Website, and Creator has not relied on 
                    any statement other than those in this supplement.
                  </p>
                </li>
                <li>
                  <p>
                    Creator’s signing and performance of this supplement will not conflict with or violate (1) any order, 
                    judgment, or decree that applies to Creator; or (2) any agreement that applies to Creator.
                  </p>
                </li>
                <li>
                  <p>
                    Creator’s performance under this supplement will not:
                  </p>
                  <ol>
                    <li>
                      <p>
                        invade the right of privacy or publicity of anyone (including invasion of rights of celebrity);
                      </p>
                    </li>
                    <li>
                      <p>
                        involve any defamatory, obscene, indecent, or otherwise unlawful material;
                      </p>
                    </li>
                    <li>
                      <p>
                        violate any law, including, but not limited to, 18 U.S.C. § 1591 (sex trafficking of children 
                        or by force, fraud, or coercion), and 18 U.S.C. § 2421A (promotion or facilitation of prostitution 
                        and reckless disregard of sex trafficking); or
                      </p>
                    </li>
                    <li>
                      <p>
                        otherwise infringe on the rights of any nonparties, including those of copyright, patent, 
                        service mark, trademark, trade name, trade secret, or other intellectual property rights, or 
                        engage in false advertising, unfair competition, violation of antidiscrimination law, or violation 
                        of any other right of any person.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    Content complies with this supplement, the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>, and all laws.
                  </p>
                </li>
                <li>
                  <p>
                    Creator either owns the Content (and all intellectual property rights in it) or has a valid license to 
                    offer the Content on the Website.
                  </p>
                </li>
                <li>
                  <p>
                    If Content includes nonparty material, Creator has secured all rights, licenses, written consents, 
                    and releases necessary for Creator to use that nonparty property in the Content (including 
                    Co-Authored Content) and for the later use and exploitation of that Content under this supplement.</p>
                </li>
                <li>
                  <p>
                    Content is of satisfactory quality, considering any description of it, the price, and all other 
                    relevant circumstances, including any statements Creator makes about the nature of the Content on 
                    Creator’s account or in any advertising.
                  </p>
                </li>
                <li>
                  <p>
                    Content does not depict any individual under 18 years old on the date of the production of that Content.
                  </p>
                </li>
                <li>
                  <p>
                    Creator complies with 18 U.S.C. §§ 2257–2257A and 28 C.F.R. Part 75, including inspecting and keeping 
                    all required written documents, including written documents sufficient to confirm that all subjects of the Content were at least 18 years old at the time of the production of the Content as required by 18 U.S.C. §§ 2257–2257A and 28 C.F.R. Part 75, and will provide AllFans with copies of all required written documents on request.
                  </p>
                </li>
                <li>
                  <p>
                    Creator obtains and keeps on record written consent from all persons (including Creator) depicted in the Content specific to the following areas: (1) consent to be depicted in the Content; (2) consent to allow for the public distribution of the Content and to upload the Content to the Website; and (3) if the Content will be made 
                    available for downloading by Users, consent to have the Content downloaded.
                  </p>
                </li>
                <li>
                  <p>
                    Creator verifies the identity and age of all individuals depicted in the Content to ensure that those individuals depicted are adults and can provide supporting documents on request.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>Compliance</h5>
              <p>Creator must comply with the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a> and <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a> at all times. AllFans may suspend, limit, or disable Creator’s participation at any time, with or without notice, for any violation of the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a> or <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>. Content will not be available on the Website until 
                AllFans has conducted its review of the Content and approves its posting.</p>
            </li>
            <div style={{ paddingTop: '220px' }}></div>
          </ol>
          </div>
          </div>
          
{/*       <button className="btn btn-primary btn-primary--feedback">
        <span>Feedback</span>
      </button>
      <ul className="pf-socials">
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 3.06836C6.6983 3.06836 2.3999 7.36676 2.3999 12.6684C2.3999 17.4812 5.9455 21.4556 10.5647 22.15V15.2124H8.1895V12.6892H10.5647V11.01C10.5647 8.22996 11.9191 7.00996 14.2295 7.00996C15.3359 7.00996 15.9215 7.09236 16.1983 7.12916V9.33156H14.6223C13.6415 9.33156 13.2991 10.262 13.2991 11.31V12.6892H16.1735L15.7839 15.2124H13.2991V22.17C17.9847 21.5348 21.5999 17.5284 21.5999 12.6684C21.5999 7.36676 17.3015 3.06836 11.9999 3.06836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99834 3.06836C4.91114 3.06836 2.3999 5.58192 2.3999 8.66992V16.6699C2.3999 19.7571 4.91347 22.2684 8.00147 22.2684H16.0015C19.0887 22.2684 21.5999 19.7548 21.5999 16.6668V8.6668C21.5999 5.5796 19.0863 3.06836 15.9983 3.06836H7.99834ZM17.5999 6.26836C18.0415 6.26836 18.3999 6.62676 18.3999 7.06836C18.3999 7.50996 18.0415 7.86836 17.5999 7.86836C17.1583 7.86836 16.7999 7.50996 16.7999 7.06836C16.7999 6.62676 17.1583 6.26836 17.5999 6.26836ZM11.9999 7.86836C14.6471 7.86836 16.7999 10.0212 16.7999 12.6684C16.7999 15.3156 14.6471 17.4684 11.9999 17.4684C9.3527 17.4684 7.1999 15.3156 7.1999 12.6684C7.1999 10.0212 9.3527 7.86836 11.9999 7.86836ZM11.9999 9.46836C11.1512 9.46836 10.3373 9.8055 9.73716 10.4056C9.13705 11.0057 8.7999 11.8197 8.7999 12.6684C8.7999 13.5171 9.13705 14.331 9.73716 14.9311C10.3373 15.5312 11.1512 15.8684 11.9999 15.8684C12.8486 15.8684 13.6625 15.5312 14.2626 14.9311C14.8628 14.331 15.1999 13.5171 15.1999 12.6684C15.1999 11.8197 14.8628 11.0057 14.2626 10.4056C13.6625 9.8055 12.8486 9.46836 11.9999 9.46836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.4042 3.66797C3.7572 3.66797 3.37795 4.39673 3.74795 4.92773L9.73623 13.4863L3.72451 20.5137C3.33551 20.9677 3.65776 21.668 4.25576 21.668H4.91982C5.21282 21.668 5.49154 21.5394 5.68154 21.3164L10.9198 15.1797L14.8632 20.8145C15.2382 21.3485 15.8499 21.668 16.5019 21.668H19.8358C20.4828 21.668 20.8621 20.9402 20.4921 20.4102L14.1737 11.3672L19.9003 4.6582C20.2323 4.2682 19.9553 3.66797 19.4433 3.66797H18.5976C18.3056 3.66797 18.0278 3.79558 17.8378 4.01758L12.996 9.67773L9.39443 4.52344C9.02043 3.98744 8.40976 3.66797 7.75576 3.66797H4.4042Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0001 3.86719C8.6513 3.86719 4.30479 4.70625 4.30479 4.70625L4.29385 4.71875C2.76863 4.96268 1.6001 6.27329 1.6001 7.86719V12.6672V12.6687V17.4672V17.4688C1.60159 18.23 1.87439 18.9657 2.36954 19.5439C2.86468 20.1221 3.54972 20.5049 4.30166 20.6234L4.30479 20.6281C4.30479 20.6281 8.6513 21.4688 12.0001 21.4688C15.3489 21.4688 19.6954 20.6281 19.6954 20.6281L19.697 20.6266C20.4497 20.5082 21.1356 20.1252 21.6311 19.5463C22.1266 18.9674 22.3993 18.2307 22.4001 17.4688V17.4672V12.6687V12.6672V7.86719C22.399 7.10569 22.1263 6.36955 21.6312 5.79103C21.136 5.21252 20.4507 4.82955 19.6985 4.71094L19.6954 4.70625C19.6954 4.70625 15.3489 3.86719 12.0001 3.86719ZM9.6001 8.98594L16.0001 12.6672L9.6001 16.3484V8.98594Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
      </ul> */}
    </div>
        </>
  );
};

export default CreatorTerms;
